import { JSX } from 'react';

import {
  ICustomRenderCellJSXProps,
  IListViewTableColumns,
  IListViewTablePagination,
  Order,
  RowsPerPage,
} from '~/src/dash/components/tables/ListViewTable/common';
import { TAdBreaksListKey } from '~/src/dash/views/inventory-rules-v2/AdBreaks/config';
import { NameWithDefault } from '~/src/dash/views/inventory-rules-v2/common';

interface IInventoryRulesTableModalConfig {
  cypressClassName: string;
  defaultState: {
    activeColumnKeys: string[];
    orderDirection: Order;
    orderBy: TAdBreaksListKey;
    page: number;
    rowsPerPage: RowsPerPage;
  };
  timezone: string;
  columns: IListViewTableColumns;
  table: IListViewTablePagination;
  activeColumnKeys: string[];
  columnSelector: {
    resetKeys: string[];
  };
}

export const inventoryRulesTableModalConfig: IInventoryRulesTableModalConfig = {
  cypressClassName: 'inventory-rules-list-modal',
  defaultState: {
    activeColumnKeys: [],
    orderDirection: 'desc',
    orderBy: 'ID',
    page: 0,
    rowsPerPage: 10,
  },
  timezone: 'UTC',
  activeColumnKeys: [],
  columns: {
    ID: {
      formatValue: (value: number) => value.toString(),
      isHidden: true,
      key: 'ID',
      label: 'ID',
      requestKey: 'ID',
      responseKey: 'ID',
      valueType: 'string',
    },
    Name: {
      cellJSX: (props: ICustomRenderCellJSXProps): JSX.Element =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        NameWithDefault({ ...props, fallbackName: 'UnnamedRule' }),
      cellRenderType: 'name',
      defaultOrderDirection: 'asc',
      headerRenderType: 'name',
      key: 'Name',
      label: 'Rule Name',
      tKey: 'RuleName',
      requestKey: 'Name',
      responseKey: 'Name',
      valueType: 'string',
      orderByKey: 'Name',
    },
  },
  table: {
    order: 'desc',
    orderBy: 'ID',
    page: 0,
    rowsPerPage: 10,
  },
} as unknown as IInventoryRulesTableModalConfig;
